module.exports = __webpack_public_path__ + "static/media/S (136).5964f3e1.jpg";